module.exports = __webpack_public_path__ + "img/2.3f2d0a6b.png";